$(document).ready(function() {
  $('#ruffruff-table-of-contents').appendTo('#table-contents');
});

document.addEventListener("touchstart", function() {},false);

var cart_config = document.getElementById('cart-config');
var cart_config_ = JSON.parse(cart_config.innerHTML || '{}');
Shopify.money_format = cart_config_.money_format

var $window = $(window);

$window.on('resize', function(){
}).trigger('resize');


$(document).ready(function() {
  $('.trigger-addtocart').on('click', function() {
    $(this).addClass('loading');
    $('.product-add .product__add-button').click();
  });

  $('.trigger-klaviyo-notify').on('click', function() {
    $(this).addClass('loading');
    $('.klaviyo-notify-btn.klaviyo-bis-trigger')[0].click();
  });

  setTimeout(function() {
    window.dispatchEvent(new Event('resize'));
  }, 1000)

  $('.atc-btn-sticky').click(function() {
    console.log('clicked')
    $(this).text('Adding...')
    $('.product-add #addToCart').click()
  });

  $('.product-info-tooltip .close').click(function() {
    $(this).closest('.product-info-tooltip').removeClass('active');
  });

  $('body').on('click', '.tooltip', function() {
    $(this).next('.product-info-tooltip').addClass('active')
  });
  
  $('body').on('click','.tooltip-hover .product-info-tooltip.active', function(e) {
    if (e.target !== this)
      return;
    $('.product-info-tooltip.active').removeClass('active');
  });

  $('.product-tabs .tab').click(function() {
    $(this).closest('.product-detail-tabs').find('.active').removeClass('active');
    var tab = $(this).attr('tab')
    $(this).addClass('active');
    $(this).closest('.product-detail-tabs').find('.tab-content[content="' + tab + '"]').addClass('active')
  })

  $('.cart-links__link-search').click(function(e) {
    e.preventDefault();
    $('.header-search-overlay').fadeIn();
    $('.announcement-bar__search-input').focus();
  });

  $('.search-bar__close').click(function(e) {
    e.preventDefault();
    $('.header-search-overlay').fadeOut();
  });

  $('.collection-tab-list .tab').click(function() {
    var container = $(this).closest('.collection-tabs-section');
    container.find('.tab').removeClass('active');
    $(this).addClass('active')
    var tab = $(this).attr('tab-name');

    container.find('.collection-product-grid .product-grid').removeClass('show');
    container.find('.collection-product-grid .product-grid[tab-name="' + tab + '"]').addClass('show');

    if(tab == 'DOG PRODUCTS') {
      $(this).closest('.collection-tabs-section').find('.tab-name-selector').text('Dog Supplements');
    }
    else {
      $(this).closest('.collection-tabs-section').find('.tab-name-selector').text('Cat Supplements');
    }
  });

  $('.btn-form-submit').on('click', function() {
    $('#customer_login').removeAttr('data-login-with-shop-sign-in')
    $('#customer-login [name="checkout_url"]').remove();
    $('.btn-form-submit-hidden').click();
  });

});

$(document).ready(function() {
  
  if($(window).width() > 768) {
    $('body').on('mouseenter', '.tooltip-hover .tooltip',function() {
      var tooltipContainer = $(this).parent().find('.product-info-tooltip');
      tooltipContainer.addClass('active');
    });
    $('body').on('mouseleave', '.tooltip-hover',function() {
      $(this).find('.product-info-tooltip').removeClass('active')
    });
  }

  $('[name="selling_plan-1"]').on('change', function() {
    if($('[name="selling_plan-1"][value="subscription"]:checked').length > 0) {
      $('.afterpay-wrapper').addClass('active');
    }
    else {
      $('.afterpay-wrapper').removeClass('active');
    }
  });

  $('.most-popular-variant label').click();

  $('body').on('change', '.product-grid-addtocart select', function() {
    var optionPrice = $(this).find('option:selected', this).attr('variant-price');
    $(this).closest('.product-index').find('.product-info .price').html(optionPrice)
  })
  
});
